import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AceModule } from 'ngx-ace-wrapper';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { EventSelectorComponent } from './event-selector/event-selector.component';
import { PostTypeEditorComponent } from './post-type-editor/post-type-editor.component';
import { PostTypeFilterSettingsComponent } from './post-type-editor/post-type-filter-settings/post-type-filter-settings.component';
import { PostTypeGeneralSettingsComponent } from './post-type-editor/post-type-general-settings/post-type-general-settings.component';
import { PostTypeIconSettingsComponent } from './post-type-editor/post-type-icon-settings/post-type-icon-settings.component';
import { PostTypeTemplatesSettingsComponent } from './post-type-editor/post-type-templates-settings/post-type-templates-settings.component';
import { PostTypesTableComponent } from './post-types-table/post-types-table.component';
import { RoutingModule } from './the-loop.routing.module';

import { LexiconModule } from '@galaxy/lexicon';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';

@NgModule({
  declarations: [
    EventSelectorComponent,
    PostTypesTableComponent,
    PostTypeEditorComponent,
    PostTypeGeneralSettingsComponent,
    PostTypeIconSettingsComponent,
    PostTypeTemplatesSettingsComponent,
    PostTypeFilterSettingsComponent,
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatToolbarModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    PageHeaderComponent,
    RoutingModule,
    MatTooltipModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatCardModule,
    MatSelectModule,
    MatTabsModule,
    AceModule,
    GalaxySnackbarModule,
    MatCheckboxModule,
    GalaxyPageModule,
    LexiconModule.forChild(),
  ],
  providers: [],
})
export class TheLoopModule {}
